const SITE_NAME = "Nordiska Uterum";
const TITLE_MAX = 60;
const DESC_MAX = 160;
const DESC_MIN = 120;

function stripBrandSuffix(title: string): string {
  return title
    .replace(/\uFEFF/g, "")
    .replace(
      /\s*\|\s*Nordiska Inglasningar(?:\s*\|\s*Nordiska Uterum)?\s*$/i,
      ""
    )
    .replace(/\s*\|\s*Nordiska Uterum\s*$/i, "")
    .trim();
}

/** One brand suffix, max 60 characters. */
export function formatSeoTitle(title: string, max = TITLE_MAX): string {
  const base = stripBrandSuffix(title);
  const suffix = ` | ${SITE_NAME}`;
  if ((base + suffix).length <= max) return base + suffix;
  const budget = max - suffix.length;
  const clipped = base
    .slice(0, budget)
    .replace(/\s+\S*$/, "")
    .replace(/\s+(i|av|och|för|till|med|den|det|att|en|ett|på|om|från)$/i, "")
    .replace(/[….:;,–-]+$/, "")
    .trim();
  return `${clipped}${suffix}`;
}

/** Sentence-case meta, 120–160 characters, no BOM. */
export function formatSeoDescription(raw: string, max = DESC_MAX): string {
  let text = raw
    .replace(/\uFEFF/g, "")
    .replace(/\s+/g, " ")
    .trim();
  if (text.length <= max) return text;
  const clipped = text
    .slice(0, max)
    .replace(/\s+\S*$/, "")
    .replace(/\s+(i|av|och|för|till|med|den|det|att|en|ett|på|om|från)$/i, "")
    .replace(/[….:;,–-]+$/, "")
    .trim();
  return `${clipped}.`;
}

export function isThinFaqMeta(meta: string, title: string): boolean {
  const cleanMeta = meta.replace(/\uFEFF/g, "").trim();
  const cleanTitle = title.replace(/\uFEFF/g, "").trim();
  if (!cleanMeta) return true;
  const norm = (s: string) => s.toLowerCase().replace(/[?!.]/g, "").trim();
  return norm(cleanMeta) === norm(cleanTitle);
}

export { SITE_NAME, TITLE_MAX, DESC_MAX, DESC_MIN };
